import React from "react";
import { API_URL } from "../../../constants/api";
import { apiPost } from "../../../utils/api_service";
import { encodeEmail, validatePassword } from "../../../utils/generic";
import { ShowToast, toastType } from "../../../utils/toast-service";
import ValidateOtp from "../ValidateOtp/ValidateOtp";

class SignUp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      view: "login",
      email: null,
      password: null,
      RepeatPassword: null,
      phoneNumber: null
    };
  }

  /** Registration field validations */
  register = () => {
    const { email, password ,RepeatPassword} = this.state;
    if (email == null || email == "") {
      ShowToast("Please enter username", toastType.ERROR, 5000, 200);
      return false;
    } else if (password == null || password == "") {
      ShowToast("Please enter password", toastType.ERROR, 5000, 200);
      return false;
    } else if (
      RepeatPassword == null ||
      RepeatPassword == ""
    ) {
      ShowToast("Please enter the repeat password", toastType.ERROR, 5000, 200);
      return false;
    }

    if (password !==RepeatPassword) {
      ShowToast("Password do not match", toastType.ERROR, 5000, 200);
      return false;
    }

    if (validatePassword(password) == false) {
      ShowToast(
        "Password must be greater than 8 alphanumeric characters and at-least one of the special characters in (!,@,#,$,%,^,&,*)",
        toastType.ERROR,
        5000,
        200
      );
      return false;
    }

    const postBody = {
      email: email,
      password: password,
      otp: "string"
    };
    apiPost({
      url: API_URL.tenant.Register,
      postBody: postBody
    }).then(response => {
      if (response.data.success == false) {
        ShowToast(response.data.message, toastType.ERROR, 5000, 200);
      } else {
        ShowToast(response.data.message, toastType.SUCCESS, 5000, 200);
        this.setState({ view: "otp", phoneNumber: response.data.data });
      }
    });
  };

  /** Resend OTP */
  resendOTP = () => {
    const { email, password } = this.state;
    const postBody = {
      email: email,
      password: password,
      otp: "string"
    };
    apiPost({
      url: API_URL.tenant.Register,
      postBody: postBody
    }).then(response => {
      if (response.data.success == true) {
        ShowToast("OTP sent successfully", toastType.SUCCESS, 5000, 200);
      } else {
        ShowToast(
          "There is issue with sending OTP",
          toastType.SUCCESS,
          5000,
          200
        );
      }

      //console.log(response);
    });
  };

  /** Verify OTP */
  verifyOTP = otp => {
    const { email, password } = this.state;
    const {resetPassword}= this.props;
    const postBody = {
      email: email,
      password: password,
      otp: otp
    };
    
    apiPost({
      url: API_URL.tenant.VerifyOTP,
      postBody: postBody
    }).then(response => {
      if (response.data.success == false) {
        ShowToast(response.data.message, toastType.ERROR, 5000, 200);
      } else if (response.data.success == true) {
        ShowToast(response.data.message, toastType.SUCCESS, 5000, 200);

        resetPassword("logIn");
      }
    });
  };

  /** Set Values */
  setValues = (value, FieldName) => {
    if (FieldName == "Password") {
      this.setState({ password: value });
    } else if (FieldName == "RepeatPassword") {
      this.setState({ RepeatPassword: value });
    } else {
      this.setState({ email: value });
    }
  };

  render() {
    const {view,email,phoneNumber} =this.state;
    return (
      <>
        {view == "login" ? (
          <div>
            <div>
              <label>{"User Email"}</label>
              <br />
              <input
                type={"text"}
                name={"User Name"}
                className={"text-field bg-login bgImgSet"}
                onBlur={event => {
                  this.setValues(event.target.value, "Email");
                }}
              />
            </div>
            <div>
              <label>{"Password"}</label> <br />
              <input
                type={"password"}
                name={"Password"}
                className={"text-field bg-password bgImgSet"}
                onBlur={event => {
                  event.target.value != null
                    ? this.setValues(event.target.value, "Password")
                    : ShowToast(
                        "Please enter the password",
                        toastType.ERROR,
                        5000,
                        200
                      );
                }}
              />
            </div>
            <div>
              <label>{"Repeat Password"}</label> <br />
              <input
                type={"password"}
                name={"RepeatPassword"}
                className={"text-field bg-password bgImgSet"}
                onBlur={event => {
                  event.target.value != null
                    ? this.setValues(event.target.value, "RepeatPassword")
                    : ShowToast(
                        "Please enter the repeat password",
                        toastType.ERROR,
                        5000,
                        200
                      );
                }}
              />
            </div>

            <div className={"d-flex"} style={{ marginTop: "15px" }}>
              <div className={"w-30"}>
                <button
                  type={"button"}
                  className={"login-button"}
                  onClick={() => this.register()}
                >
                  {"Sign Up\r"}
                </button>
              </div>
              {/* <div className="w-30">Reset Password</div> */}
            </div>
          </div>
        ) : (
          <ValidateOtp
            email={encodeEmail(email)}
            verifyOTP={this.verifyOTP}
            resendOTP={this.resendOTP}
            phoneNumber={phoneNumber}
          />
        )}
      </>
    );
  }
}

export default SignUp;
